export const modalFooterCss = {
  width: "100%",
  display: "flex" as const,
  flexDirection: "row" as const,
  justifyContent: "end" as const,
  alignItems: "end" as const,
  paddingRight: "16px",
  paddingBottom: "16px",
};
